export default {
  homeTileLabel: 'Ver Analytics',
  selectDashboardLabel: 'Tablero',
  loadingDashboard: 'Cargando el tablero…',
  previewModeTitle: 'Vista previa',
  previewModeMessage: 'El tablero real se conectará próximamente. Este espacio tiene el mismo tamaño que tendrá el tablero.',
  testEnvironmentBadge: 'Ambiente de pruebas',
  aadConnectTitle: 'Inicia sesión con Microsoft',
  aadConnectMessage: 'Este tablero no tiene credenciales de servicio configuradas. Inicia sesión con una cuenta Microsoft con acceso al workspace.',
  aadConnectButton: 'Conectar con Microsoft',
  aadConnectError: 'No se pudo iniciar sesión o el tablero no cargó. Verifica que tu cuenta tenga acceso al workspace.',
  noDashboardsTitle: 'No tienes tableros de Analytics asignados.',
  reportsLoadingTitle: 'Cargando tus tableros…',
  reportsLoadErrorTitle: 'No pudimos cargar tus tableros.',
  noAccessTitle: 'No tienes acceso a este tablero.',
  noAccessSubtitle: 'Solicita el acceso a tu administrador.',
  loadErrorTitle: 'No se pudo cargar el tablero.',
  loadErrorSubtitle: 'Intenta de nuevo o contacta a soporte.',
  upstreamErrorTitle: 'No se pudo conectar con Power BI.',
  upstreamErrorSubtitle: 'Intenta de nuevo más tarde.',
  refresh: 'Actualizar',
  fullscreen: 'Pantalla completa',
  print: 'Imprimir',
  printError: 'No se pudo abrir el diálogo de impresión. Revisa que el navegador no esté bloqueando ventanas emergentes.',
  download: 'Descargar',
  formatPdf: 'PDF',
  formatPptx: 'PowerPoint',
  downloadDialogTitle: 'Descargar tablero ({format})',
  downloadPreparing: 'Preparando tu descarga…',
  downloadInProgress: 'Generando el documento… {percent}%',
  downloadReady: 'Listo, iniciando la descarga…',
  downloadCloseButton: 'Cerrar',
  downloadClosedHint: 'La descarga sigue en proceso. Te avisaremos en tus notificaciones cuando esté lista.',
  downloadGenerateAnotherLink: '¿Cambiaste los filtros? Generar otra descarga',
  downloadAnotherStarted: 'Se generó una nueva descarga. La anterior sigue su curso y te avisaremos por separado.',
  downloadSuccess: 'Tu tablero se descargó.',
  downloadFileError: 'El documento se generó pero no se pudo descargar. Lo encontrarás en tus notificaciones.',
  downloadErrorBookmark: 'No pudimos leer los filtros del tablero. Recarga la página e intenta de nuevo.',
  downloadErrorForbidden: 'No tienes acceso a este tablero.',
  downloadErrorInvalidFormat: 'Formato no soportado.',
  downloadErrorBookmarkTooLarge: 'No se pudo guardar el estado del tablero. Intenta con menos filtros aplicados.',
  downloadErrorRateLimited: 'Alcanzaste el límite de descargas por hora. Intenta de nuevo en {minutes} min.',
  downloadErrorDisabled: 'La descarga de tableros está temporalmente deshabilitada.',
  downloadErrorNotSupported: 'Este tablero no se puede descargar.',
  downloadErrorConfig: 'Error en la configuración, contacta a soporte.',
  downloadErrorUpstream: 'No se pudo conectar con Power BI. Intenta de nuevo más tarde.',
  downloadErrorNotFound: 'No encontramos esa descarga.',
  downloadErrorFailed: 'Power BI no pudo generar el documento.',
  downloadErrorTimeout: 'La descarga tardó demasiado. Intenta de nuevo más tarde.',
  downloadErrorCapacityBusy: 'El servicio está saturado. Intenta de nuevo en unos minutos.',
  downloadErrorUnexpected: 'No se pudo completar la descarga. Intenta de nuevo.',

  // Admin de Analytics del super admin
  hub_title: 'Analytics',
  hub_subtitle: 'Administra los tableros de Power BI y quién puede verlos.',
  tab_organizations: 'Organizaciones',
  tab_dashboards: 'Catálogo de tableros',
  source_banner_text: 'Los cambios todavía no están activos. Los accesos que ves y editas aquí se guardan, pero los usuarios siguen viendo ' +
    'los de la configuración anterior hasta que se active esta fuente. Puedes preparar todo desde ahora.',

  dashboard_new_button: 'Nuevo tablero',
  dashboards_empty: 'No hay tableros para mostrar.',
  dashboard_search_placeholder: 'Buscar tablero',
  filter_type: 'Tipo',
  filter_status: 'Estado',
  filter_all: 'Todos',
  filter_status_active: 'Activos',
  filter_status_inactive: 'Inactivos',

  column_position: '#',
  column_dashboard: 'Tablero',
  column_type: 'Tipo',
  column_organizations: 'Organizaciones',
  column_users: 'Usuarios',
  column_status: 'Estado',

  dashboard_type_general: 'General',
  dashboard_type_specific: 'Específico',
  dashboard_type_general_desc: 'Parte del kit que se ofrece a cualquier organización',
  dashboard_type_specific_desc: 'Hecho a la medida de una o pocas organizaciones',
  dashboard_status_active: 'Activo',
  dashboard_status_inactive: 'Inactivo',
  action_activate: 'Activar',
  action_deactivate: 'Desactivar',
  action_change_connection: 'Cambiar conexión',

  dashboard_reorder_button: 'Reordenar',
  dashboard_reorder_hint: 'Este es el orden por default y solo incluye los tableros generales: los específicos conservan su lugar. ' +
    'Las organizaciones con orden personalizado no cambian.',
  dashboard_reorder_changed: 'Orden modificado',
  dashboard_reorder_save: 'Guardar orden',

  dashboard_incomplete_chip: 'Config. incompleta',
  dashboard_incomplete_field_singular: 'Falta el {field} de Power BI',
  dashboard_incomplete_field_plural: 'Faltan: {fields} de Power BI',
  dashboard_incomplete_banner_title: 'Este tablero no cargará hasta completar su conexión con Power BI',
  dashboard_incomplete_banner_detail_singular: 'Falta el {field}. El resto de la configuración está lista.',
  dashboard_incomplete_banner_detail_plural: 'Faltan: {fields}. El resto de la configuración está lista.',
  dashboard_incomplete_banner_hint: 'Se puede guardar incompleto, pero no cargará para nadie hasta completarlo.',

  dashboard_form_title_new: 'Nuevo tablero',
  dashboard_card_identity: 'Identidad',
  dashboard_card_connection: 'Conexión con Power BI',
  dashboard_card_availability: 'Disponibilidad',
  dashboard_field_optional: '(opcional)',
  dashboard_field_required: 'Este campo es obligatorio',
  dashboard_field_name: 'Nombre',
  dashboard_field_name_placeholder: 'Ej. Tablero Mermas',
  dashboard_field_description: 'Descripción',
  dashboard_field_description_placeholder: 'Se muestra debajo del nombre en el catálogo',
  dashboard_field_paste_url: 'Pegar URL de Power BI',
  dashboard_field_paste_url_placeholder: 'https://app.powerbi.com/groups/.../reports/...',
  dashboard_field_paste_url_helper: 'Pega la URL del reporte para completar los IDs automáticamente. No se guarda — es solo una ' +
    'ayuda; también puedes llenar los campos de abajo manualmente.',
  dashboard_field_paste_url_applied: 'Datos extraídos de la URL la última vez',
  dashboard_field_paste_url_unrecognized: 'URL no reconocida. Usa la del reporte dentro de su workspace; las de apps de Power BI no ' +
    'incluyen el workspace.',
  dashboard_field_workspace_id: 'Workspace ID',
  dashboard_field_report_id: 'Report ID',
  dashboard_field_dataset_id: 'Dataset ID',
  dashboard_field_rls_role: 'Rol RLS',
  dashboard_field_rls_role_placeholder: 'Ej. RolCliente',
  dashboard_field_guid_placeholder: 'GUID',
  dashboard_field_guid_missing_placeholder: 'Falta — pégalo desde Power BI',
  dashboard_field_guid_invalid: 'Debe tener el formato de un GUID (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx).',
  dashboard_field_type: 'Tipo',

  dashboard_usage_title: 'Dónde se usa',
  dashboard_usage_summary: 'Habilitado en {organizations} · {users}',
  dashboard_usage_organizations_count: '{count} organización | {count} organizaciones',
  dashboard_usage_users_count: '{count} usuario con acceso | {count} usuarios con acceso',
  dashboard_usage_search_placeholder: 'Buscar organización',
  dashboard_usage_no_results: 'No hay organizaciones que coincidan',
  dashboard_usage_empty_new: 'Después de guardarlo, habilítalo en una organización desde su detalle.',
  dashboard_usage_empty: 'Aún no habilitado en ninguna organización. Habilítalo desde el detalle de una organización.',
  dashboard_usage_empty_incomplete_singular: 'Aún no habilitado en ninguna organización. No podrá habilitarse hasta completar el {field}.',
  dashboard_usage_empty_incomplete_plural: 'Aún no habilitado en ninguna organización. No podrá habilitarse hasta completar: {fields}.',


  dashboard_deactivate_title: 'Desactivar tablero',
  dashboard_deactivate_message: '{name} dejará de verse en {organizations} ({users}). ' +
    'La configuración y los accesos se conservan: si lo reactivas, vuelven.',
  dashboard_deactivate_users_count: '{count} usuario | {count} usuarios',
  dashboard_connection_title: 'Cambiar la conexión con Power BI',
  dashboard_connection_message: '{name} se usa en {organizations} ({users}). ' +
    'Al guardar, se mostrará el reporte de la nueva conexión.',

  notify_saved: 'Tablero guardado',
  notify_reordered: 'Orden guardado',
  notify_reorder_stale: 'El catálogo cambió mientras ordenabas. Vuelve a ordenar.',
  notify_activated: 'Tablero activado',
  notify_deactivated: 'Tablero desactivado',
  notify_error: 'Ocurrió un error. Intenta de nuevo.',

  organizations_enable_button: 'Habilitar Analytics en una organización',
  organizations_search_placeholder: 'Buscar organización por nombre o ID',
  organizations_kpi_active: 'Organizaciones activas',
  organizations_kpi_users: 'Usuarios con acceso',
  organizations_kpi_attention: 'Requieren atención',
  organizations_kpi_attention_caption: 'Clic para filtrar',
  organization_filter_all: 'Todas',
  organization_filter_active: 'Activas',
  organization_filter_paused: 'Pausadas',
  organization_filter_attention: 'Requieren atención',
  organizations_empty_title: 'Todavía ninguna organización tiene Analytics',
  organizations_empty_text: 'Habilita Analytics en tu primera organización para elegir sus tableros y quién puede verlos.',
  organizations_no_results: 'No hay organizaciones que coincidan con «{search}»',
  organizations_no_results_status: 'No hay organizaciones con ese estado',
  organizations_no_results_filter_hint: 'El filtro de estado puede estar ocultando resultados.',
  organizations_clear_search: 'Limpiar búsqueda',

  column_id: 'ID',
  column_organization: 'Organización',
  column_dashboards: 'Tableros',
  column_users_with_access: 'Usuarios con acceso',

  organization_status_active: 'Activa',
  organization_status_paused: 'Pausada',
  organization_rls_missing_chip: 'Falta',
  organization_attention_hint: 'Requiere atención: sin Identidad RLS',
  organization_id_subtitle: 'ID {id}',
  organization_active_toggle: 'Analytics activo',
  organization_paused_title: 'Analytics está pausado para {organization}',
  organization_paused_text: 'Los cambios se guardan pero nadie los ve hasta reactivarla.',
  organization_load_error: 'No se pudo cargar la organización.',
  tab_org_dashboards: 'Tableros',
  tab_org_users: 'Usuarios',

  enable_title: 'Habilitar Analytics',
  enable_field_organization: 'Organización',
  enable_field_organization_hint: 'Solo se muestran organizaciones activas o en demo que todavía no tienen Analytics.',
  enable_no_organizations: 'No hay organizaciones disponibles',
  enable_field_rls_placeholder: 'Ej. {id}',
  enable_field_rls_hint: 'Valor acordado con quien mantiene el dataset de Power BI del cliente. Filtra sus datos: ' +
    'un valor equivocado puede mostrarle datos de otra organización.',
  enable_rls_same_as_id: 'Igual al ID de la organización',
  enable_rls_change: 'Cambiar',
  enable_rls_empty_warning: 'Podrás capturarla después, pero los tableros no cargarán hasta entonces.',
  enable_field_dashboards: 'Tableros a habilitar',
  enable_select_all: 'Seleccionar todos',
  enable_clear_all: 'Quitar todos',
  enable_incomplete_tooltip: 'Configuración incompleta',
  enable_dashboards_empty: 'No hay tableros en este grupo',
  enable_dashboards_no_match: 'Ningún tablero coincide con «{search}»',
  enable_dashboards_error: 'No se pudo cargar el catálogo de tableros.',
  action_retry: 'Reintentar',
  enable_submit: 'Habilitar',
  group_general: 'Kit general',
  group_specific: 'Específicos',

  rls_label: 'Identidad RLS',
  rls_hint: 'Filtra los datos de esta organización dentro de Power BI',
  rls_missing_title: 'Sin Identidad RLS',
  rls_missing_text: 'Ningún tablero cargará para esta organización',
  rls_capture: 'Capturar',
  rls_edit_title: 'Editar Identidad RLS',
  rls_capture_title: 'Capturar Identidad RLS',
  rls_current_value: 'Valor actual',
  rls_new_value: 'Valor nuevo',
  rls_warning: 'Un valor equivocado puede mostrar a {organization} los datos de otra organización.',
  rls_confirm: 'Confirmo que este valor corresponde a {organization} (ID {id})',

  order_catalog: 'Catálogo',
  order_catalog_hint: 'Sigue el orden del catálogo y se actualiza con él',
  order_custom: 'Personalizado',
  order_custom_hint: 'Esta organización tiene su propio orden',
  enabled_title: 'Habilitados ({count})',
  enabled_drag_hint: 'Arrastra para reordenar',
  enabled_empty_title: 'Esta organización todavía no tiene tableros',
  enabled_empty_text: 'Agrégalos desde la lista de «Disponibles», a la derecha →',
  enabled_empty_add_kit: 'Agregar todo el kit general',
  available_title: 'Disponibles',
  available_add: 'Agregar',
  available_add_kit: 'Agregar todo el kit',
  available_has_kit: 'Ya tiene todo el kit',
  available_incomplete: 'Configuración incompleta en el catálogo',
  pending_remove: 'Se quitará al guardar',
  pending_add: 'Se agregará al guardar',
  pending_undo: 'Deshacer',
  pending_added_count: '{count} tablero agregado | {count} tableros agregados',
  pending_removed_count: '{count} tablero quitado | {count} tableros quitados',
  pending_save: 'Guardar cambios',

  pause_title: 'Pausar Analytics para {organization}',
  pause_message: 'Nadie tiene acceso a sus tableros todavía. Nada se borra: al reactivarla, todo vuelve como estaba. | ' +
    'El usuario con acceso dejará de ver sus tableros de inmediato. Nada se borra: al reactivarla, recupera el acceso. | ' +
    'Los {count} usuarios con acceso dejarán de ver sus tableros de inmediato. Nada se borra: al reactivarla, recuperan el acceso.',
  action_pause: 'Pausar',
  remove_title: 'Quitar tablero | Quitar tableros',
  remove_message_singular: '{dashboard} dejará de verse para {users} de {organization}. ' +
    'Sus accesos se conservan: si lo vuelves a habilitar, lo recuperan.',
  remove_message_plural: '{dashboards} dejarán de verse para {users} de {organization}. ' +
    'Sus accesos se conservan: si los vuelves a habilitar, los recuperan.',
  action_remove: 'Quitar',
  discard_title: '¿Descartar los cambios?',
  discard_message: 'Los cambios en los tableros de esta organización no se han guardado.',
  discard_message_unsaved: 'Los cambios que hiciste no se han guardado.',
  discard_keep: 'Seguir editando',
  action_discard: 'Descartar',

  organization_users_subtitle: 'ID {id} · {count} usuario en la organización | ID {id} · {count} usuarios en la organización',
  users_search_placeholder: 'Buscar por nombre o correo',
  users_filter_access: 'Acceso',
  users_access_with: 'Con acceso',
  users_access_without: 'Sin acceso',
  users_filter_dashboard: 'Tablero',
  users_filter_franchise: 'Unidad de negocio',
  users_dashboard_any: 'Cualquiera',
  users_search_widened: 'Mostrando todos los usuarios que coinciden',
  users_no_dashboards_title: 'Primero habilita tableros para {organization}',
  users_no_dashboards_text: 'Todavía no hay ningún tablero habilitado en esta organización, ' +
    'así que no hay nada que darle a sus usuarios.',
  users_go_to_dashboards: 'Ir a Tableros',
  users_empty_title: 'Nadie en {organization} tiene acceso todavía',
  users_empty_text: 'Busca un usuario de {organization} arriba para darle acceso al único tablero habilitado. | ' +
    'Busca un usuario de {organization} arriba para darle acceso a alguno de sus {count} tableros habilitados.',
  users_no_results: 'No hay usuarios que coincidan',
  users_clear_filters: 'Limpiar búsqueda y filtros',

  column_user: 'Usuario',
  column_franchise: 'Unidad de negocio',
  user_suspended: 'Suspendido',
  user_suspended_tooltip: 'Usuario suspendido: no puede recibir acceso',
  dashboard_header_count: '{name} · {count}',
  dashboard_inactive_tooltip: 'Inactivo en el catálogo: nadie lo ve',
  dashboard_incomplete_tooltip: 'Configuración incompleta: nadie lo ve',

  users_selected_count: '{count} usuario seleccionado | {count} usuarios seleccionados',
  users_clear_selection: 'Limpiar selección',
  users_grant_menu: 'Dar acceso a…',
  users_revoke_menu: 'Quitar acceso a…',
  users_all_dashboards: 'Todos los tableros ({count})',
  grant_all_title: 'Dar acceso a todos los tableros ({count})',
  grant_all_message: 'Vas a dar acceso a todos los tableros habilitados de {organization} a {count} usuario: {people}. ' +
    'Los que ya tenían acceso no cambian. | ' +
    'Vas a dar acceso a todos los tableros habilitados de {organization} a {count} usuarios: {people}. ' +
    'Los que ya tenían acceso no cambian.',
  grant_one_title: 'Dar acceso a {dashboard}',
  grant_one_message: 'Vas a dar acceso a {dashboard} a {count} usuario de {organization}: {people}. ' +
    'Los que ya lo tenían no cambian. | ' +
    'Vas a dar acceso a {dashboard} a {count} usuarios de {organization}: {people}. ' +
    'Los que ya lo tenían no cambian.',
  revoke_all_title: 'Quitar el acceso a todos los tableros',
  revoke_all_message: '{count} usuario de {organization} dejará de ver sus tableros de inmediato: {people}. | ' +
    '{count} usuarios de {organization} dejarán de ver sus tableros de inmediato: {people}.',
  revoke_one_title: 'Quitar el acceso a {dashboard}',
  revoke_one_message: '{count} usuario de {organization} dejará de ver {dashboard} de inmediato: {people}. | ' +
    '{count} usuarios de {organization} dejarán de ver {dashboard} de inmediato: {people}.',
  grant_skipped_suspended: 'Se omite {count} usuario suspendido, que no puede recibir acceso. | ' +
    'Se omiten {count} usuarios suspendidos, que no pueden recibir acceso.',
  action_grant: 'Dar acceso',
  action_revoke: 'Quitar acceso',
  people_more: '{count} más',

  notify_enabled: 'Analytics habilitado en {organization}',
  notify_paused: 'Analytics pausado en {organization}',
  notify_reactivated: 'Analytics reactivado en {organization}',
  notify_rls_saved: 'Identidad RLS guardada',
  notify_dashboards_saved: 'Cambios guardados',
  notify_dashboards_stale: 'El catálogo cambió mientras editabas. Revisa los tableros y vuelve a guardar.',
  notify_access_granted: 'Acceso dado a {count} usuario | Acceso dado a {count} usuarios',
  notify_access_revoked: 'Acceso quitado a {count} usuario | Acceso quitado a {count} usuarios',
  notify_access_granting: 'Asignando permiso… | Asignando permisos…',
  notify_access_revoking: 'Quitando permiso… | Quitando permisos…',
  notify_access_saved_grant: 'Permiso asignado | Permisos asignados',
  notify_access_saved_revoke: 'Permiso quitado | Permisos quitados',
  notify_only_suspended: 'Los usuarios seleccionados están suspendidos y no pueden recibir acceso',
  notify_selection_limit: 'Puedes seleccionar hasta {count} usuarios a la vez',
  notify_access_unchanged_grant: 'Sin cambios: ya tenían ese acceso',
  notify_access_unchanged_revoke: 'Sin cambios: no tenían ese acceso',
  notify_dashboard_not_enabled: 'Ese tablero no está habilitado para {organization} | ' +
    'Esos tableros no están habilitados para {organization}',
  notify_users_not_in_organization: 'Algunos usuarios ya no son de {organization} o fueron suspendidos'
}
